<template>
<!-- eslint-disable max-len -->
<div>
  <v-app-bar class="ma-0">
    <v-container class="mw">
      <v-row>
        <v-col>
          <img alt="Kearney logo" src="@/assets/kearneylogo.png" />
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>

  <v-container v-if="pageState === 'Loading'" class="mw">
    <v-row class="ma-12 pa-12" justify="center">
      <v-progress-circular :size="120"
                            :width="3"
                            color="primary"
                            indeterminate></v-progress-circular>
    </v-row>
  </v-container>

  <v-container v-if="pageState === 'Invalid'" class="mw">
    <v-row class="mb-12 mt-12">
      <v-col>
        <v-card class="ma-12">
          <v-card-title>Something went wrong...</v-card-title>
          <v-card-text justify="center">
            Failed to load the survey. Please contact
            support@resonatesolutions.com.au for assistance.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>


  <v-container v-if="pageState === 'Valid' && isOptOut === true && currentStep < surveyFlow.length" class="mw">
    <v-row class="mb-12 mt-12">
      <v-col>
        <v-form>
          <OptOut v-bind:optout="optout"></OptOut>
        </v-form>
      </v-col>
    </v-row>
  </v-container>

  <v-container v-if="pageState === 'Valid' && currentStep >= surveyFlow.length" class="mw">
    <v-row class="mb-12 mt-12">
      <v-col>
        <div>
          <Outro></Outro>
        </div>
      </v-col>
    </v-row>
  </v-container>

  <v-container v-if="pageState === 'Valid' && isOptOut === false && currentStep < surveyFlow.length" class="mw mb-4">
    <v-form method="post" ref="form" action="#" v-model="valid">
      <v-row>
        <v-col>
          <v-stepper v-model="currentStep">
            <v-stepper-items>
              <v-stepper-content class="no-transition" v-for="(surveyPage, i) in surveyFlow" :step="i + 1" :key="i + 1">

                <div v-if="surveyPage == 'Intro'">
                  <Intro></Intro>
                </div>

                <div v-if="currentStep == i + 1 && (surveyPage != 'Intro' && surveyPage !=  'Summary' && surveyPage !=  'SurveyEnd'  && surveyPage !=  'Nominate')">
                  <div>
                    <v-row class="mb-4 mt-4">
                      <v-col>
                        <div>
                          <p class="display-1 font-weight-light primary--text">{{questions[i - 1].title}}</p>
                        </div>
                      </v-col>
                    </v-row>
                    <p v-if="isSelfSurvey" class="font-weight-black">
                      Please tell us the extent to which you agree with the following statements about yourself.
                    </p>
                    <p v-else class="font-weight-black">
                      Please tell us the extent to which you agree with the following statements about {{ params.EvaluateeFullName }}.
                    </p>
                  </div>
                  <Driver v-for="driver in questions[i - 1].drivers" :pageNr="i + 1"
                          :key="driver.field"
                          v-bind:driver="driver"
                          v-on:validate-form="validateForm">
                  </Driver>                      <!-- eslint-disable max-len -->
                  <Verbatim v-bind:verbatim="questions[i - 1].verbatim"></Verbatim>
                  <v-row justify="center">
                    <v-dialog v-if="currentStep == i + 1" v-model="skipPopUpOpen" persistent max-width="500">
                      <Skip @click.stop="skipPopUpOpen = true"
                            v-bind:skip="skip"
                            :key="questions[i - 1].field"
                            v-bind:suffixKey="questions[i - 1].field"
                            v-bind:skipPopUpOpen="skipPopUpOpen"
                            @closeSkipPopUp="closeSkipPopUp($event)"
                            @skipSection="skipSection(questions[i - 1])"></Skip>
                    </v-dialog>
                  </v-row>
                </div>

                <div v-if="surveyPage == 'Summary'">
                  <SummaryView v-if="currentStep == i + 1"></SummaryView>
                </div>

                <div v-if="surveyPage == 'Nominate'">
                  <Nominate></Nominate>
                </div>

                <div v-if="surveyPage == 'SurveyEnd'">
                  <Outro></Outro>
                </div>

                <v-footer v-if="pageState === 'Valid' && currentStep != surveyFlow.length && surveyPage != 'SurveyEnd' && surveyPage != 'Intro'"
                          fixed
                          padless
                          app
                          color="grey lighten-3">
                  <v-container class="mw pa-0">
                    <v-row>
                      <v-col class="py-2">
                        <v-card flat tile color="transparent">
                          <v-card-text class="my-0 py-0">
                            <v-row class="d-flex d-sm-none  float-left font-weight-black pt-4" no-gutters>
                              <span class="mr-2">{{  currentStep - 1 }}/{{ isSelfSurvey ? (surveyFlow.length - 1) : (surveyFlow.length - 2)}}</span>
                              <v-icon v-for="i in (isSelfSurvey ? (surveyFlow.length - 1) : (surveyFlow.length - 2))"
                                      :key="i"
                                      size="10px"
                                      :color="
                                      currentStep>
                                i
                                ? 'primary'
                                : ( currentStep - 1) === i
                                ? 'primary'
                                : 'grey'
                                "
                                class="mr-1"
                                >mdi-checkbox-blank-circle
                              </v-icon>
                            </v-row>
                            <v-row class="d-none d-sm-flex float-left font-weight-black pt-4" no-gutters>
                              <span class="mr-4">STEP {{ currentStep - 1 }} OF {{ isSelfSurvey ? (surveyFlow.length - 1) : (surveyFlow.length - 2) }}</span>
                              <v-icon v-for="i in (isSelfSurvey ? (surveyFlow.length - 1) : (surveyFlow.length - 2))"
                                      :key="i"
                                      size="12px"
                                      currentStep>
                                i
                                ? 'primary'
                                : ( currentStep - 1) === i
                                ? 'primary'
                                : 'grey'
                                "
                                class="mr-1"
                                >mdi-checkbox-blank-circle
                              </v-icon>
                            </v-row>
                            <v-row class="d-flex float-right" no-gutters>
                              <v-btn large
                                     class="font-weight-black submit"
                                     color="#7823dc"
                                     @click="nextButton(surveyPage)">
                                {{surveyPage == 'Summary' ? ( isSelfSurvey ? 'Submit and Nominate' :'Submit'):(surveyPage == 'Nominate' ? 'Nominate Now':'Next')}}
                              </v-btn>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-footer>

              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-form>
  </v-container>

</div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

import Driver from '@/components/ATK_360_v1/Driver.vue';
import Intro from '@/components/ATK_360_v1/Intro.vue';
import Nominate from '@/components/ATK_360_v1/Nominate.vue';
import OptOut from '@/components/ATK_360_v1/OptOut.vue';
import Outro from '@/components/ATK_360_v1/Outro.vue';
import Skip from '@/components/ATK_360_v1/Skip.vue';
import SummaryView from '@/components/ATK_360_v1/SummaryView.vue';
import Verbatim from '@/components/ATK_360_v1/Verbatim.vue';

export default {
  name: 'Home',

  components: {
    Intro,
    Outro,
    Driver,
    SummaryView,
    Verbatim,
    Nominate,
    OptOut,
    Skip,
  },

  data() {
    return {
      valid: true,
      skipPopUpOpen: false,
    };
  },

  computed: {
    ...mapGetters([
      'surveyFlow',
      'isSelfSurvey',
    ]),
    pageState() {
      if (this.$store.state.params === 'Init') return 'Loading';
      if (this.$store.state.params === '') return 'Invalid';
      return 'Valid';
    },
    questions() {
      const eligibleQuestions = [];
      for (let i = 0; i < this.$store.state.questions.length; i += 1) {
        if (this.surveyFlow.indexOf(this.$store.state.questions[i].field) !== -1) {
          eligibleQuestions.push(this.$store.state.questions[i]);
        }
      }
      return eligibleQuestions;
    },
    params() {
      return this.$store.state.params;
    },
    optout() {
      return this.$store.state.optout;
    },
    skip() {
      return this.$store.state.skip;
    },
    isOptOut() {
      return this.$route.query.isOptout === 'true';
    },
    currentStep: {
      get() {
        return this.$store.getters.currentStep;
      },
      set(newValue) {
        this.$store.commit('setCurrentStep', newValue);
      },
    },
  },

  methods: {
    validateForm() {
      this.$refs.form.validate();
    },
    nextButton(surveyPage) {
      if (this.$refs.form.validate()) {
        if (surveyPage === 'Nominate' && this.$store.state.params.NominationLink) {
          window.location.href = this.$store.state.params.NominationLink;
        } else {
          this.$store.commit('incrementCurrentStep');
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        const isCompleted = surveyPage === 'Summary' || (this.$store.state.currentStep === this.surveyFlow.length);
        this.$store.commit('storeResponse', {
          k: 'IsCompleted',
          v: isCompleted,
        });

        // Completed
        if (isCompleted) {
          this.$store.commit('completeSurvey');
          this.$store.commit('storeResponse', {
            k: 'DateCompleted',
            v: new Date(),
          });
        }

        if (this.$store.state.response[`${this.skip.field}_${surveyPage}`] != null) {
          this.$store.commit('storeResponse', {
            k: `${this.skip.field}_${surveyPage}`,
            v: '',
          });
        }

        if (this.$store.state.response[`${this.skip.verbatim.field}_${surveyPage}`] != null) {
          this.$store.commit('storeResponse', {
            k: `${this.skip.verbatim.field}_${surveyPage}`,
            v: '',
          });
        }

        if (this.$store.state.previousStep) {
          this.$store.commit('previousPage', this.$store.state.previousStep);
          this.$store.state.previousStep = null;
        }

        this.$store.dispatch('storeResponse');
      }
    },
    skipSection(question) {
      for (let i = 0; i < question.drivers.length; i += 1) {
        delete this.$store.state.response[`${question.drivers[i].field}_Rating`];
      }
      delete this.$store.state.response[`${question.verbatim.field}`];

      if (this.$store.state.previousStep) {
        this.$store.commit('previousPage', this.$store.state.previousStep);
        this.$store.state.previousStep = null;
      } else {
        this.$store.commit('incrementCurrentStep');
      }

      this.skipPopUpOpen = false;
      this.$store.dispatch('storeResponse');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    },
    closeSkipPopUp() {
      this.skipPopUpOpen = false;
    },
  },

  mounted() {
    axios
      .get(`api/SurveyContext/Context/?shortcode=${this.$route.query.l}&encryptedCode=${this.$route.query.e ? encodeURIComponent((this.$route.query.e).replace(/ /g, '+')) : undefined}`)
      .then((res) => {
        this.$store.commit('setParams', res.data);
        const keys = Object.keys(res.data);
        for (let i = 0; i < keys.length; i += 1) {
          this.$store.commit('storeResponse', {
            k: keys[i],
            v: res.data[keys[i]],
          });
        }

        // Try to restore previous state
        axios
          .post('api/response/lastResponse', res.data)
          .then((lastRes) => {
            if (lastRes && lastRes.data) {
              const lastRespkeys = Object.keys(lastRes.data);
              for (let i = 0; i < lastRespkeys.length; i += 1) {
                this.$store.commit('storeResponse', {
                  k: lastRespkeys[i],
                  v: lastRes.data[lastRespkeys[i]],
                });
              }
            }
          });
      })
      .catch(() => this.$store.commit('setParams', ''));
  },
};
</script>

<style scoped>
.mw {
  max-width: 900px;
}

.submit {
  border-color: #7823dc;
  color: white;
}

.v-stepper {
  background: #fafafa !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.v-stepper__content {
  padding: 0 !important;
}

.v-app-bar {
  border-bottom: 1px solid grey !important;
  box-shadow: none !important;
}
</style>
